import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import api from '../api/client';

// Avviso in testa ai portali utenti/allenatori (29/10/2026, titolare): quando la società conferma che un torneo
// FIPAV è stato annullato, gli atleti delle coppie coinvolte lo vedono qui finché non lo chiudono.
// Prima della conferma della società non compare nulla (il sospetto del sync lo vede solo la società).
export default function AvvisoAnnulloFipav() {
  const [avvisi, setAvvisi] = useState([]);
  useEffect(() => {
    let vivo = true;
    api.get('/fipav/annullamenti/miei').then(r => { if (vivo) setAvvisi(r.data || []); }).catch(() => {});
    return () => { vivo = false; };
  }, []);
  const chiudi = (id) => {
    setAvvisi(a => a.filter(x => x.id !== id));
    api.post(`/fipav/richieste/${id}/visto-annullo`).catch(() => {});
  };
  if (!avvisi.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
      {avvisi.map(a => (
        <div key={a.id} role="alert" style={s.box}>
          <AlertTriangle size={20} color="#B42318" style={{ flexShrink: 0, marginTop: '2px' }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 800 }}>Torneo annullato dalla FIPAV</div>
            <div style={{ fontSize: '14px', marginTop: '2px' }}>
              {a.torneo}{a.compagno ? ` · con ${a.compagno}` : ''}. La società ha verificato che il torneo non si gioca: la partecipazione non viene conteggiata e la trovi nello storico delle tue iscrizioni.
            </div>
            {a.nota && <div style={{ fontSize: '13px', marginTop: '4px', color: 'var(--text-muted)' }}>Nota della società: {a.nota}</div>}
            <button style={s.ok} onClick={() => chiudi(a.id)}>Ho visto</button>
          </div>
          <button style={s.x} onClick={() => chiudi(a.id)} aria-label="Chiudi"><X size={16} /></button>
        </div>
      ))}
    </div>
  );
}
const s = {
  box: { display: 'flex', gap: '12px', alignItems: 'flex-start', background: '#FEF3F2', color: '#1D1D1F', border: '1px solid #FECDCA', borderLeft: '4px solid #B42318', borderRadius: '14px', padding: '12px 14px' },
  ok: { marginTop: '8px', border: 'none', background: '#B42318', color: '#fff', borderRadius: '999px', padding: '6px 14px', fontWeight: 700, fontSize: '13px', cursor: 'pointer' },
  x: { border: 'none', background: 'none', cursor: 'pointer', color: '#6E6E73', padding: '4px', display: 'flex' },
};
